module.exports = __webpack_public_path__ + "img/logo-argini.e08b7211.png";